import React from "react";
import { useState, useEffect } from 'react'
import axios from "axios";
import $ from 'jquery'
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import './MobileDetails.css'

export default function MobileDetails() {
    var parameter1 = useParams();
    var mobN = parameter1.parameter2.split('-')[0].split(' ')[0];
    if (parameter1.parameter1 != mobN) {
        window.location.href = '/'
    }
    parameter1.parameter1 = parameter1.parameter1.replace(/-/g, ' ').replace(/\b./g, function (m) { return m.toUpperCase() }).replace(',', '');
    parameter1.parameter2 = parameter1.parameter2.replace(/-/g, ' ').replace(/\b./g, function (m) { return m.toUpperCase() }).replace(',', '');
    var parameter = parameter1.parameter2.replace(/-/g, ' ').replace(/-/g, ' ').replace(/_/g, ' ').trim();

    const mName = parameter.trimEnd(' ').split(' ');
    var mobileName = "";
    for (var i = 0; i < mName.length; i++) {
        if (i == 0) {
            mobileName = mobileName + mName[i] + "_";
        }
        else {
            mobileName = mobileName + mName[i] + "-";
        }
    }
    mobileName = mobileName.substring(0, mobileName.length - 1);

    const [mobiledetails, setmobiledetails] = useState([]);
    const [mobiledetailserr, setmobiledetailserr] = useState(0);
    useEffect(() => {
        axios.get("https://api.phoneshone.com/api/Home/GetMobileSetTable?Name=" + mobileName.toLowerCase())
            .then(response => {
                if (response.data.length > 0) {
                    setmobiledetails(response.data);
                }
                else {
                    axios.get("https://api.phoneshone.com/api/Home/GetMobileCommingSoonTable?Name=" + mobileName.toLowerCase())
                        .then(response => {
                            if (response.data.length > 0) {
                                setmobiledetails(response.data);
                            }
                            else {
                                setmobiledetailserr(1);
                            }
                        })
                        .catch(err => {
                            //console.log(err);
                            setmobiledetailserr(1);
                        })
                }
            })
            .catch(err => {
                //console.log(err);
                setmobiledetailserr(1);
            })
    }, []);
    //console.log(mobiledetails);

    ////////////////////////////////////////////////////////
    function loadTrendData(mob_name1) {
        $.ajax({
            url: "https://api.phoneshone.com/api/Home/GetSpecificMobile",
            type: "get",
            data: { Name: mob_name1, pageNumber: 1, pageSize: 20 },
            dataType: "json",
            beforeSend: function () {

            },
            success: function (data) {
                if (data.length > 0) {
                    var div = $(".container .trnd");
                    var card = '';
                    $.each(data, function (i, row) {
                        var mob_name = row.nameModel.trim();
                        card = '<div class="col-md-6 section_card"><a href="https://www.phoneshone.com/' + mob_name.split(' ')[0].toLowerCase() + '/' + mob_name.replace(/\s/g, "-").toLowerCase() + '">' +
                            '<p class="bg-dark p-2 text-white" style="font-size: 20px">' + row.nameModel + ' Price in Pakistan</p></a></div>'
                        div.append(card);
                        $("#divtrndtable").show();
                        $(".count").text($(".section_card").length);
                    });
                } else {
                    var len = $(".section_card").length;
                    if (len == 0) {
                        $("#divtrndtable").hide();
                    }
                }
            },
            error: function (data) {

            },
            complete: function () {

            }
        });
    }

    ///////////////////////////////////////////////////////////
    useEffect(() => {
        $("#divtrndtable").hide();
        loadTrendData(parameter1.parameter1);
    }, []);

    var currentUrl = window.location.href;
    var lastElement = currentUrl[currentUrl.length - 1];
    var newUrl = currentUrl.slice(0, -1);
    if (lastElement == "/") {
        window.history.pushState({}, null, newUrl);
    }

    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const weekNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const d = new Date();
    let year = d.getFullYear().toString();
    let month = monthNames[d.getMonth()].toString();
    let dayOfWeek = weekNames[d.getDay()].toString();
    let date = d.getDate().toString();

    const btndetailmob = (e) => {
        $("#table").removeAttr("hidden");
    }

    const btncomparemob = (e) => {
        var mobile = e.currentTarget.id;
        var mob_name = mobile.trim();
        window.location.href = 'https://phoneshone.com/mobiles/compare/' + mob_name.replace(/\s+/g, "-").toLowerCase() + '-vs-';
    }

    return (
        <>
            <Helmet>
                <title>{parameter} Mobile Price in Pakistan - {month} {year}</title>
                <meta name="description" content={parameter + " Price, Features and Specifications in Pakistan " + month + ' ' + year} />
                <link rel="canonical" href={window.location.href} />
            </Helmet>
            <br />
            <div class="container-fluid" style={{ backgroundColor: '#3a3837', color: 'white' }}>
                <div class="row justify-content-center text-center" style={{ padding: '1%', fontSize: '190%' }}>
                    {parameter} Price In Pakistan {year}
                </div>
            </div>
            <br />
            <div class="container">
                <br />
                {
                    mobiledetailserr == 1 ?
                        <div class="row border-0">
                            <div class="col-12 text-center pt-2">
                                <h6><strong class="text-dark"><i class="fa fa-exclamation-circle"></i> No Details Are Available For Now</strong></h6>
                            </div>
                        </div>
                        : mobiledetails.length == 0 ? <div className="loader"></div>
                            : <>
                                <div className="row justify-content-center">
                                    <div className="col-md-5 text-center border-0 mt-auto mb-auto">
                                        <h4 className="font-weight-bold" style={{ fontFamily: 'Times New Roman, Times, serif' }}>{parameter1.parameter2}</h4>
                                        <h5 className="font-weight-bold" style={{ fontFamily: 'Times New Roman, Times, serif' }}>{mobiledetails[0].price}</h5>
                                    </div>
                                    <div className="col-md-5 border-0 box mb-md-0 mb-4 pt-3 pb-3">
                                        <img src={mobiledetails[0].image} className="openImage" alt={parameter1.parameter2} style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: '40%' }} />
                                    </div>
                                </div>
                                <br />
                                <div class="row justify-content-center">
                                    <div class="col-md-10 col-12">
                                        <div class="row ml-0 mr-0 cats-listing justify-content-center">
                                            <div class="col-md-6 col-12 text-center p-0">
                                                <a class="btncomparemob" onClick={(e) => btncomparemob(e)} id={parameter1.parameter2}><i class="fa fa-exchange" aria-hidden="true"></i> Compare</a>
                                            </div>
                                            <div class="col-md-6 col-12 text-center p-0">
                                                <a class="btndetailmob" onClick={(e) => btndetailmob(e)} ><i class="fa fa-info-circle" aria-hidden="true"></i> Details</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div class="row justify-content-center">
                                    <div class="col-md-10 col-12">
                                        <p class="text-justify">
                                            {parameter1.parameter2} Price in Pakistan is {mobiledetails[0].price} as updated on {dayOfWeek} {date} {month}, {year}.
                                            Get all the latest updates of {parameter1.parameter2} in Lahore, Karachi, Islamabad and other cities of Pakistan.
                                            {parameter1.parameter2} includes a professional-grade camera with the highest resolution available in a smartphone {parameter1.parameter2} Price in Pakistan.
                                            {parameter1.parameter2} is a high-end mid-range smartphone. {parameter1.parameter2} it comes with powerful specifications and features
                                            molded in a trend-setting design.
                                        </p>
                                    </div>
                                </div>
                                <div class="row justify-content-center" hidden id="table">
                                    <div class="col-10" dangerouslySetInnerHTML={{ __html: mobiledetails[0].mobileSetData.replace('Build', parameter1.parameter2 + ' Build').replace('Frequency', parameter1.parameter2 + ' Frequency').replace('Processor', parameter1.parameter2 + ' Processor').replace('Display', parameter1.parameter2 + ' Display').replace('Memory', parameter1.parameter2 + ' Memory').replace('Camera', parameter1.parameter2 + ' Camera').replace('Connectivity', parameter1.parameter2 + ' Connectivity').replace('Features</td>', parameter1.parameter2 + ' Features</td>').replace('Battery', parameter1.parameter2 + ' Battery').replace('Price', parameter1.parameter2 + ' Price').replace('Ratings', parameter1.parameter2 + ' Ratings') }} />
                                </div>
                            </>
                }
            </div>
            <br />
            <div class="container-fluid" id="divtrndtable">
                <div class="row">
                    <div class="container-fluid" style={{ backgroundColor: '#3a3837', color: 'white' }}>
                        <div class="row justify-content-center text-center p-1" style={{ fontSize: '190%' }}>
                            Trending Mobile Phones of {parameter1.parameter1.replace(/-/g, ' ').replace(/\b./g, function (m) { return m.toUpperCase() }).replace(',', '')}
                        </div>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="container">
                        <div class="row trnd justify-content-center"></div>
                    </div>
                </div>
            </div>
            <br /><br /><br /><br />
        </>
    )
}